import { Button } from '@mantine/core';
import { IconBuilding, IconUser } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { ContactKind } from 'src/Services/API/generated';

import styles from './ContactKindSectionForm.module.scss';
import { Props } from './ContactKindSectionForm.types';

const ContactKindSectionForm = ({ form }: Props) => {
  const { t } = useTranslation();

  const choose = (kind: ContactKind) => {
    form.setFieldValue('kind', kind);
    form.setFieldValue('kindTouched', true);
  };

  const options = [
    { kind: ContactKind.Person, icon: IconUser, label: t('contacts.kind.person', 'Une personne') },
    {
      kind: ContactKind.Company,
      icon: IconBuilding,
      label: t('contacts.kind.company', 'Une entreprise ou un organisme'),
    },
  ];

  return (
    <div className={styles.container} role="radiogroup">
      {options.map(({ kind, icon: Icon, label }) => {
        const selected = form.values.kind === kind;
        return (
          <Button
            key={kind}
            role="radio"
            aria-checked={selected}
            variant={selected ? 'primary' : 'outline'}
            size="lg"
            leftSection={<Icon size={22} />}
            className={styles.option}
            onClick={() => choose(kind)}
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
};

export default ContactKindSectionForm;
